import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sm-switch',
  templateUrl: './sm-switch.component.html',
  styleUrls: ['./sm-switch.component.scss']
})
export class SmSwitchComponent {
  @Input() classes: string;
  @Input() inputId: string;
  @Input() isChecked: boolean = false;
  @Input() label: string;
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() checkboxChange = new EventEmitter();

  onCheckboxChange(e: Event) {
    if (this.disabled !== true) {
      this.checkboxChange.emit(e);
    }
  }
}
